import React from "react";

import { Button } from "react-admin";

import { ShowIcon } from "./iconography";
import { deepRedirect } from "../../utils/utils";

export const ShowButton = ({
  label = "Show",
  basePath,
  record,
  idSource,
  history,
  backPath,
  state,
  disabled = false,
  ...props
}) => {
  const handleRedirect = () => {
    if (record.externalUrl) {
      window.open(record.externalUrl, "_blank");
    } else {
      const toPath = `${basePath}/${
        idSource ? record[idSource] : record.id
      }/show`;
      deepRedirect(history, toPath, backPath, state);
    }
  };

  return basePath && record ? (
    <Button label={label} onClick={handleRedirect} disabled={disabled}>
      <ShowIcon />
    </Button>
  ) : null;
};
